import { IFormInputProps } from '../../components/merchants/FormInput';
import { InputType } from '../../components/form/form-input-constants';
import { AGENCY_FORM_FIELD, AGENCY_FORM_FIELD_NAMES } from './new-agency-form';

export const NEW_AGENCY_INPUTS = (): IFormInputProps[] => ([
	{
		key: AGENCY_FORM_FIELD.RISK_FEE,
		fieldName: AGENCY_FORM_FIELD.RISK_FEE,
		placeholder: AGENCY_FORM_FIELD_NAMES.RISK_FEE,
		label: AGENCY_FORM_FIELD_NAMES.RISK_FEE,
		inputType: InputType.Number,
		required: true,
		additionalClasses: 'col-sm-12 col-md-6',
		autoComplete: 'off'
	},
	{
		key: AGENCY_FORM_FIELD.PERCENTAGE,
		fieldName: AGENCY_FORM_FIELD.PERCENTAGE,
		placeholder: AGENCY_FORM_FIELD_NAMES.PERCENTAGE,
		label: AGENCY_FORM_FIELD_NAMES.PERCENTAGE,
		inputType: InputType.Number,
		required: true,
		additionalClasses: 'col-sm-12 col-md-6',
		autoComplete: 'off'
	},
	{
		key: AGENCY_FORM_FIELD.FEE_AMOUNT,
		fieldName: AGENCY_FORM_FIELD.FEE_AMOUNT,
		placeholder: AGENCY_FORM_FIELD_NAMES.FEE_AMOUNT,
		label: AGENCY_FORM_FIELD_NAMES.FEE_AMOUNT,
		inputType: InputType.Number,
		required: true,
		additionalClasses: 'col-sm-12 col-md-6',
		autoComplete: 'off'
	},
	{
		key: AGENCY_FORM_FIELD.REFUND_FEE,
		fieldName: AGENCY_FORM_FIELD.REFUND_FEE,
		placeholder: AGENCY_FORM_FIELD_NAMES.REFUND_FEE,
		label: AGENCY_FORM_FIELD_NAMES.REFUND_FEE,
		inputType: InputType.Number,
		required: true,
		additionalClasses: 'col-sm-12 col-md-6',
		autoComplete: 'off'
	},
	{
		key: AGENCY_FORM_FIELD.CHARGEBACK_FEE,
		fieldName: AGENCY_FORM_FIELD.CHARGEBACK_FEE,
		placeholder: AGENCY_FORM_FIELD_NAMES.CHARGEBACK_FEE,
		label: AGENCY_FORM_FIELD_NAMES.CHARGEBACK_FEE,
		inputType: InputType.Number,
		required: true,
		additionalClasses: 'col-sm-12 col-md-6',
		autoComplete: 'off'
	},
]);
